// extracted by mini-css-extract-plugin
module.exports = {" _key":"@dojo/widgets/grid-cell","root":"grid-cell-m__root__ESfel"};